if(location.hash) {
  const urlParams = location.hash
  const target = document.getElementById(urlParams.replace(/^#/, ''))

  console.log(urlParams)
  console.log(target)

  target.open = true;
}
const ankerLinkArr = document.querySelectorAll('[data-sizeguide-link]')
Array.from(ankerLinkArr).forEach(value => {
  value.addEventListener('click', () => {
    const index = value.href.indexOf('#')
    const targetId = value.href.slice(index)

    const target = document.querySelector(targetId)

    target.open = true;
  })
})


// サイズ切り替え
const unitArr = document.querySelectorAll('[data-change-unit]')
unitArr.forEach(value => {
  value.addEventListener('click', () => {
    let current = value
    const unitCm = value.parentElement.nextElementSibling.querySelectorAll('[data-cm]')
    value.classList.toggle('active')
    console.log(current.dataset.changeUnit);

    if(current.dataset.changeUnit == 'cm') {
      console.log('inch');
      current.dataset.changeUnit = 'inch'
      unitCm.forEach(value => {
        value.innerHTML = value.dataset.inch
      })
    } else {
      console.log('cm');
      current.dataset.changeUnit = 'cm'
      unitCm.forEach(value => {
        value.innerHTML = value.dataset.cm
      })
    }
  })
})

// タブ切り替え
const tabArr = document.querySelectorAll('[data-tab]')
if(tabArr) {
  tabArr.forEach((value) => {
    const targetValue = value.querySelectorAll('li')
    targetValue.forEach((target, index) => {
      target.addEventListener('click', () => {
        targetValue.forEach(value => {
          value.classList.remove('active')
        })
        Array.from(value.nextElementSibling.children).forEach(value => {
          value.classList.remove('active')
        })
        target.classList.add('active')
        value.nextElementSibling.children[index].classList.add('active')
      })
    })
  })
}

// SPメニュー
const menuBtn = document.querySelector('[data-sizeguide-icon]')
const menu = document.querySelector('[data-sizeguide-popup]')
const menuClose = document.querySelector('[data-sizeguide-close]')

document.addEventListener('click', (e) => {
  if(!e.target.closest('[data-sizeguide-icon]')) {
    menu.classList.remove('active')
  }
  else {
    menu.classList.add('active')
  }
})